import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.addEventListener('asset:image-changed', (e) => {
      const { kind, src } = e.detail || {}
      if (!src) return
      this.updateMobilePreviewImage(kind, src)
    })
  }

  updateImageContainer(){
    return Array.from(this.element.querySelectorAll('.device-preview'))
      .filter(el => el && !el.classList.contains("hidden")) || []
  }

  updateMobilePreviewImage(kind, src) {
    const containers = this.updateImageContainer()
    if (containers.length < 1) return

    containers.forEach(container => {
      if (kind === 'logo') {
        const logoImg = container.querySelector('img[alt*="Iberia"]') || container.querySelector('img')
        if (logoImg) logoImg.src = src
        return
      }

      if (kind === 'cover') {
        const cover = container.querySelector('[style*="background-image"]')
        if (cover) cover.style.backgroundImage = `url('${src}')`
      }
    })
  }
}
